import React, { Component, Fragment } from "react";
import InfoBlock from "../presentational/InfoBlock";
import PersonCards from "../presentational/PersonCards";
import { textToLink } from "../functions/textToLink";
import { downloadUrl } from "../config";

class PersonsBlock extends Component {
  persons = [
    {
      name: "Илиян Динев",
      avatar: "https://www.w3schools.com/w3css/img_avatar3.png"
    },
    {
      name: "Ваньо Иванов",
      avatar: "https://www.w3schools.com/w3css/img_avatar2.png"
    },
    {
      name: "Елена Андонова-Костова",
      avatar: "https://www.w3schools.com/w3css/img_avatar4.png"
    }
  ];

  render() {
    return (
      <InfoBlock title="УПРАВЛЕНСКА СТРУКТУРА">
        <PersonCards persons={this.persons} />
      </InfoBlock>
    );
  }
}

class StructureBlock extends Component {
  section = textToLink("УСТРОЙСТВЕНИ АКТОВЕ И ДРУГИ ДОКУМЕНТИ");

  render() {
    return (
      <InfoBlock title="УСТРОЙСТВЕНИ АКТОВЕ И ДРУГИ ДОКУМЕНТИ">
        {window.documentsList[this.section].map((document, index) => {
          const href = `${downloadUrl}${this.section}/${encodeURIComponent(document)}`;
          return (
            <p key={index}>
              <a href={href} target="_blank">
                {document}
              </a>
            </p>
          );
        })}
      </InfoBlock>
    );
  }
}

class AuditorBlock extends Component {
  render() {
    return (
      <InfoBlock title="ИНФОРМАЦИЯ ЗА ОДИТОРИТЕ">
        <p>
          <b>Г-жа Магдалена Николова Цветкова</b> - Регистриран одитор, член на Института на
          дипломираните експерт-счетоводители в България (ИДЕС), с диплома № 0659, съгласно Списъка
          на дипломираните експерт-счетоводители – регистрирани одитори, членове на ИДЕС в България.
        </p>
      </InfoBlock>
    );
  }
}

class CorporateContainer extends Component {
  render() {
    return (
      <Fragment>
        <PersonsBlock />
        <StructureBlock />
        <AuditorBlock />
      </Fragment>
    );
  }
}

export default CorporateContainer;



// WEBPACK FOOTER //
// ./src/containers/Corporate.js